import AvailableAgentsCapacityMetric from "../available-agents-capacity-metric";
import useAgents from "hooks-for/agents/use-agents";
import { AgentStateType } from "@edgetier/watchtower-types";
import { faComments } from "@fortawesome/pro-duotone-svg-icons";
import { FunctionComponent, memo } from "react";
import { IProps } from "./mean-agent-capacity-metric.types";
import { LIVE_POLL_INTERVAL_MILLISECONDS } from "constants/pages/live";
import { parseUrlArray } from "@edgetier/utilities";
import { useQueryParameters } from "@edgetier/client-components";
import "./mean-agent-capacity-metric.scss";

/**
 * Display the average current capacity of all agents.
 * @returns Mean capacity metric.
 */
const MeanAgentCapacityMetric: FunctionComponent<IProps> = () => {
    const { tagId } = useQueryParameters({ tagId: parseUrlArray });

    // Get all agents in Available state
    const { data: agents, isLoading: isAgentsCountLoading } = useAgents(
        { agentStateType: AgentStateType.Available, tagId },
        { refetchInterval: LIVE_POLL_INTERVAL_MILLISECONDS }
    );
    return (
        <AvailableAgentsCapacityMetric
            isLoading={isAgentsCountLoading}
            aggregate={(values) => {
                return Array.isArray(agents) && agents.length > 0
                    ? values.reduce((total, value) => total + value, 0) / agents.length
                    : 0;
            }}
            icon={faComments}
            title="Agent Average Concurrency"
            tooltipContent="Average number of interactions per available agent"
        />
    );
};

export default memo(MeanAgentCapacityMetric);
